import { render } from "./chat.vue?vue&type=template&id=9416a190"
import script from "./chat.js?vue&type=script&lang=js&external"
export * from "./chat.js?vue&type=script&lang=js&external"

import "./chat.vue?vue&type=style&index=0&id=9416a190&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__